// Approved visual-only helper bodies; no demo initialization.
module.exports = function makeFoil({
  ctx,
  CARD,
  cardFront,
  peelDirection
}) {
  const state = {};
  Object.defineProperty(state, "peelDirection", {
    get: peelDirection
  });

  function rounded(x, y, w, h, r) {
    ctx.beginPath();
    ctx.roundRect(x, y, w, h, r);
  }

  function text(s, x, y, size, color, align = 'center', weight = '400', family = 'system-ui') {
    ctx.font = "".concat(weight, " ").concat(size, "px ").concat(family);
    ctx.fillStyle = color;
    ctx.textAlign = align;
    ctx.textBaseline = 'middle';
    ctx.fillText(s, x, y);
  }

  function cardOutline(box = CARD) {
    const {
      x,
      y,
      w,
      h
    } = box;
    rounded(x, y, w, h, 15);
  }

  function cardBack(box = CARD) {
    const {
      x,
      y,
      w,
      h
    } = box;
    ctx.save();
    cardOutline(box);
    ctx.clip();
    const g = ctx.createLinearGradient(x, y, x + w, y + h);
    g.addColorStop(0, '#712f37');
    g.addColorStop(.5, '#321826');
    g.addColorStop(1, '#652635');
    ctx.fillStyle = g;
    ctx.fillRect(x, y, w, h);
    ctx.lineWidth = .6;
    ctx.strokeStyle = '#d4ab6d24';

    for (let yy = y - 60; yy < y + h + 70; yy += 17) {
      ctx.beginPath();
      ctx.moveTo(x, yy);
      ctx.lineTo(x + w, yy + w);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(x + w, yy);
      ctx.lineTo(x, yy + w);
      ctx.stroke();
    }

    ctx.lineWidth = 1;

    for (let d of [8, 13, 23]) {
      rounded(x + d, y + d, w - d * 2, h - d * 2, Math.max(4, 15 - d / 2));
      ctx.strokeStyle = d === 13 ? '#dcbd8caa' : '#bd965950';
      ctx.stroke();
    }

    ctx.save();
    ctx.translate(x + w / 2, y + h / 2);
    ctx.rotate(Math.PI / 4);
    ctx.strokeStyle = '#dab88299';
    ctx.strokeRect(-63, -63, 126, 126);
    ctx.strokeStyle = '#ae875944';
    ctx.strokeRect(-74, -74, 148, 148);
    ctx.restore();
    ctx.beginPath();
    ctx.ellipse(x + w / 2, y + h / 2, 82, 112, 0, 0, Math.PI * 2);
    ctx.strokeStyle = '#e4be805e';
    ctx.stroke();
    text('OP', x + w / 2, y + h / 2 - 2, 70, '#d8b886', 'center', '950');
    text('COLLECTION', x + w / 2, y + h / 2 + 50, 8, '#ccac79', 'center', '600');
    text('✦', x + w / 2, y + 48, 20, '#b78d5d');
    text('✦', x + w / 2, y + h - 47, 20, '#b78d5d');
    ctx.restore();
  }

  function cornerPeel(p) {
    return window.OPPeelGesture.geometry(CARD, p, state.peelDirection);
  }

  function peelHint() {
    const {
      x,
      y,
      w,
      h
    } = CARD;
    ctx.save();
    rounded(x + 24, y + h * .64, w - 48, 87, 12);
    ctx.fillStyle = '#160e1ff0';
    ctx.fill();
    ctx.strokeStyle = '#f1d1a479';
    ctx.lineWidth = 1;
    ctx.stroke();
    text('按住任意位置', x + w / 2, y + h * .64 + 23, 17, '#fff0d4', 'center', '700');
    text('慢慢拖開', x + w / 2, y + h * .64 + 47, 17, '#f3d1a1', 'center', '600');
    text('上下左右・四角皆可', x + w / 2, y + h * .64 + 69, 10.5, '#d2b693');

    for (const [px, py, arrow] of [[x + 28, y + 29, '↘'], [x + w - 28, y + 29, '↙'], [x + 28, y + h - 29, '↗'], [x + w - 28, y + h - 29, '↖']]) {
      ctx.fillStyle = '#e9bc7826';
      rounded(px - 15, py - 15, 30, 30, 7);
      ctx.fill();
      text(arrow, px, py, 22, '#e8c596', 'center', '500');
    }

    ctx.restore();
  }

  function squeezedCard(p) {
    const {
      x,
      y,
      w,
      h
    } = CARD,
          g = cornerPeel(p);
    ctx.save();
    ctx.shadowColor = '#000b';
    ctx.shadowBlur = 25;
    ctx.shadowOffsetY = 14;
    cardOutline();
    ctx.fillStyle = '#191018';
    ctx.fill();
    ctx.restore();
    cardFront();
    ctx.save();
    cardOutline();
    ctx.clip();

    if (g.cover.length) {
      ctx.beginPath();
      g.cover.forEach((q, i) => i ? ctx.lineTo(q.x, q.y) : ctx.moveTo(q.x, q.y));
      ctx.closePath();
      ctx.clip();
      cardBack();
    }

    ctx.restore();

    if (p > .002 && p < .999 && g.span > 1) {
      const {
        a,
        b,
        depth
      } = g,
            nx = g.normal.x,
            ny = g.normal.y,
            dx = b.x - a.x,
            dy = b.y - a.y,
            mx = (a.x + b.x) / 2,
            my = (a.y + b.y) / 2;
      ctx.save();
      cardOutline();
      ctx.clip();
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.bezierCurveTo(a.x + dx * .3 - nx * depth * .12, a.y + dy * .3 - ny * depth * .12, b.x - dx * .3 - nx * depth * .12, b.y - dy * .3 - ny * depth * .12, b.x, b.y);
      ctx.bezierCurveTo(b.x - dx * .22 - nx * depth, b.y - dy * .22 - ny * depth, a.x + dx * .22 - nx * depth, a.y + dy * .22 - ny * depth, a.x, a.y);
      ctx.closePath();
      ctx.shadowColor = '#000c';
      ctx.shadowBlur = 9 + depth * .25;
      ctx.shadowOffsetX = nx * 8;
      ctx.shadowOffsetY = ny * 8;
      const fold = ctx.createLinearGradient(mx - nx * depth, my - ny * depth, mx + nx * 3, my + ny * 3);
      fold.addColorStop(0, '#775044');
      fold.addColorStop(.15, '#b9956e');
      fold.addColorStop(.35, '#f8e8cc');
      fold.addColorStop(.52, '#d7b58a');
      fold.addColorStop(.77, '#835941');
      fold.addColorStop(1, '#2b1722');
      ctx.fillStyle = fold;
      ctx.fill();
      ctx.shadowColor = 'transparent';
      ctx.shadowBlur = 0;
      ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
      ctx.strokeStyle = '#ffe7beaa';
      ctx.lineWidth = .9;
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.bezierCurveTo(a.x + dx * .22 - nx * depth, a.y + dy * .22 - ny * depth, b.x - dx * .22 - nx * depth, b.y - dy * .22 - ny * depth, b.x, b.y);
      ctx.stroke();
      ctx.restore();
    }

    if (p < .012) peelHint();
    if (p < .97) text('放手停住 · 反向拖可蓋回', x + w / 2, y + h + 34, 11, '#ddbf95');
  }

  return {
    cardBack,
    peelHint,
    squeezedCard
  };
};
